import classNames from "classnames";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { MetaFieldType } from "src/app/methods/getMetaFieldTypeOptions";
import { RootState } from "src/redux/reducers";
import { ITask } from "src/redux/task/taskReducer";
import { getFullDate, getImageSource } from "../../../utils/methods";
import { getDateLabel } from "../../methods/getDateLabel";

import AvatarPlaceholder from "../../../images/avatar-purple.svg";
import ContentPlaceholder from "../../../images/content-placeholder.svg";
import CustomImage from "../../components/CustomImage/CustomImage";

interface Props {
  columnType: string;
  // colData: {
  //   value: string;
  //   options: { singleSelectOptions: SingleSelectOption[] };
  //   name: string;
  // };
  colData: any;
  values: any;
  tasksAutocomplete: ITask[];
}

export const BoardColumnLabel = (props: Props) => {
  const { columnType, colData, values, tasksAutocomplete } = props;

  const intl = useIntl();

  const {
    projectReducer: { membersList },
  } = useSelector((state: RootState) => state);

  const getColumnLabel = () => {
    switch (columnType) {
      case MetaFieldType.Member:
        const memberData = membersList.find(
          (member) => member.id === colData.value,
        );
        if (!memberData) return null;
        return (
          <span className="board-column__label">
            <CustomImage
              className="board-column__label-image"
              src={memberData.avatarUrl}
              alt="avatar"
              loading="lazy"
            />
            <span className="board-column__label-text">{memberData.name}</span>
          </span>
        );

      case MetaFieldType.Date:
        const formattedValue = getDateLabel({
          lang: "en-EN",
          date: moment(colData.value),
          disableRedLabel: false,
          intl,
        });

        return (
          <span
            className={classNames(
              "board-column__label",
              formattedValue !== null ? formattedValue.style : null,
            )}
          >
            {typeof formattedValue?.date === "string"
              ? formattedValue?.date
              : getFullDate(formattedValue?.date.toDate())}
          </span>
        );

      case MetaFieldType.Creator:
      case MetaFieldType.Content:
      case MetaFieldType.PublicationRelated: {
        const foundTask = tasksAutocomplete.find(
          (task) => task.taskId === colData.value,
        );

        const placeholder =
          columnType === MetaFieldType.Creator
            ? AvatarPlaceholder
            : ContentPlaceholder;

        return (
          <span className="board-column__label">
            <CustomImage
              className="board-column__label-image"
              src={getImageSource(foundTask?.cover, "tiny", placeholder)}
              alt="avatar"
              loading="lazy"
            />
            <span className="board-column__label-text">{foundTask?.title}</span>
          </span>
        );
      }

      case MetaFieldType.SingleSelect:
        return colData.name;

      default:
        return values.find((value: string) => {
          if (value === colData.value) {
            return colData.name;
          }
        });
    }
  };

  return getColumnLabel();
};
